import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { certboxActions } from '../../../../../store/actions'
import moment from 'moment'
import { commons } from '../../../../../hook/common'

/*
   구매확인서 form
 */
const CertboxForm1 = (props) => {
  let [step, setStep] = useState(1)

  const fileType = [
    { title: '수출신고필증', value: '811' },
    { title: 'Documentary credit(수출신용장)', value: '465' },
    { title: '외화표시 물품공급계약서', value: '2AN' },
  ]

  const onSelected = (value) => {
    setStep(value)
  }
  return (
    <>
      <h3 className="h3-tit mt30">정보</h3>
      <table className="tbl-view">
        <caption>전자문서번호, 수신처(발급기관) 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">전자문서번호</th>
            <td>{props.data.crtIssueMasterDto?.docid}</td>
          </tr>
          <tr>
            <th scope="row">수신처 (발급기관)</th>
            <td>{props.data.crtIssueMasterDto?.issueNm}</td>
          </tr>
        </tbody>
      </table>
      <h3 className="h3-tit">일반정보</h3>
      <table className="tbl-view">
        <caption>신청인 정보, 상호, 성명, 사업자등록번호, 주소 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th scope="row" colSpan={2}>
              신청인 정보
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" className="th01">
              상호
            </th>
            <td>{props.data.crtIssueMasterDto?.lctorgnm}</td>
          </tr>
          <tr>
            <th scope="row" className="th01">
              성명
            </th>
            <td>{props.data.crtIssueMasterDto?.lctceonm}</td>
          </tr>
          <tr>
            <th scope="row" className="th01">
              사업자등록번호
            </th>
            <td>{props.data.crtIssueMasterDto?.lctprtid}</td>
          </tr>
          <tr>
            <th scope="row" className="th01">
              주소
            </th>
            <td>
              {props.data.crtIssueMasterDto?.lctaddr1}
              <br />
              {props.data.crtIssueMasterDto?.lctaddr2} {props.data.crtIssueMasterDto?.lctaddr3}
            </td>
          </tr>
        </tbody>
      </table>
      <table className="tbl-view mt10">
        <caption>공급자 정보, 상호, 성명, 사업자등록번호, 주소 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th scope="row" colSpan={2}>
              공급자 정보
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" className="th01">
              상호
            </th>
            <td>{props.data.crtIssueMasterDto?.splyCmpyNm}</td>
          </tr>
          <tr>
            <th scope="row" className="th01">
              성명
            </th>
            <td>{props.data.crtIssueMasterDto?.splynm}</td>
          </tr>
          <tr>
            <th scope="row" className="th01">
              사업자등록번호
            </th>
            <td>{props.data.crtIssueMasterDto?.splyprtnum}</td>
          </tr>
          <tr>
            <th scope="row" className="th01">
              주소
            </th>
            <td>
              {props.data.crtIssueMasterDto?.splyaddr1}
              <br />
              {props.data.crtIssueMasterDto?.splyaddr2} {props.data.crtIssueMasterDto?.splyaddr3}
            </td>
          </tr>
        </tbody>
      </table>
      <table className="tbl-view mt10">
        <caption>공급자에게 전자문서로 전달하는 경우 입력 (선택사항), 수발신인식별자, 상세수발신인식별자, 이메일주소 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th scope="row" colSpan={2}>
              ※공급자에게 전자문서로 전달하는 경우 입력 (선택사항)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" className="th01">
              수발신인식별자
            </th>
            <td>{props.data.crtIssueMasterDto?.splycd}</td>
          </tr>
          <tr>
            <th scope="row" className="th01">
              상세수발신인식별자
            </th>
            <td>{props.data.crtIssueMasterDto?.splyid}</td>
          </tr>
          <tr>
            <th scope="row" className="th01">
              이메일주소
            </th>
            <td>{props.data.crtIssueMasterDto?.emlAddr}</td>
          </tr>
        </tbody>
      </table>
      <ul className="nav-tab tabs mt40">
        <li
          className={step === 1 ? 'on' : ''}
          onClick={() => {
            onSelected(1)
          }}
        >
          <a href="#buy-tab1">구매물품</a>
        </li>
        <li
          className={step === 2 ? 'on' : ''}
          onClick={() => {
            onSelected(2)
          }}
        >
          <a href="#buy-tab2">수출근거서류</a>
        </li>
        <li
          className={step === 3 ? 'on' : ''}
          onClick={() => {
            onSelected(3)
          }}
        >
          <a href="#buy-tab3">세금계산서</a>
        </li>
        <li
          className={step === 4 ? 'on' : ''}
          onClick={() => {
            onSelected(4)
          }}
        >
          <a href="#buy-tab4">발급이력</a>
        </li>
      </ul>
      <div className="tab-container">
        {step === 1 && (
          <div id="buy-tab1" className="tab-cont">
            <h3 className="h3-tit mt30">총 구매 물품</h3>
            <table className="tbl-view">
              <caption>총 수량, 총 금액 항목으로 구성</caption>
              <colgroup>
                <col className="col1" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">총 수량</th>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">총 금액</th>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className="tbl-wrap mt20">
              <table className="tbl-list">
                <caption>HS부호, 품명, 규격, 수량, 구매일, 단가, 금액 항목으로 구성</caption>
                <colgroup>
                  <col style={{ width: '14%' }} />
                  <col style={{ width: '23%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '14%' }} />
                  <col style={{ width: '12%' }} />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">HS부호</th>
                    <th scope="col">품명</th>
                    <th scope="col">규격</th>
                    <th scope="col">수량</th>
                    <th scope="col">구매일</th>
                    <th scope="col">단가</th>
                    <th scope="col">금액</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data?.crtConfirmationItemDtoList?.length > 0 ? (
                    props.data?.crtConfirmationItemDtoList?.map((goods, index) => {
                      return (
                        <tr key={index}>
                          <td data-title={'HS부호'}>{goods.hsCd}</td>
                          <td data-title={'품명'}>{goods.itemnm}</td>
                          <td data-title={'규격'}>{goods.itemdeftxt}</td>
                          <td data-title={'수량'}>{goods.grcnt}</td>
                          <td data-title={'구매일'}>{moment(goods.crtYmd).format('YYYY-MM-DD')}</td>
                          <td data-title={'단가'}>{goods?.baseAmt && commons.addComma(goods.baseAmt)}</td>
                          <td data-title={'금액'}>{goods?.gramt && commons.addComma(goods.gramt)}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td colSpan={7}>
                        <div className="nodata">검색된 자료가 없습니다.</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {step === 2 && (
          <div id="buy-tab2" className="tab-cont">
            <div className="tbl-wrap mt30">
              <table className="tbl-list">
                <caption>근거서류명 및 번호, HS부호, 품명, 규격, 금액, 선적기일 항목으로 구성</caption>
                <colgroup>
                  <col style={{ width: '17%' }} />
                  <col style={{ width: '14%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '14%' }} />
                  <col style={{ width: '14%' }} />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">근거서류명 및 번호</th>
                    <th scope="col">HS부호</th>
                    <th scope="col">품명</th>
                    <th scope="col">규격</th>
                    <th scope="col">금액</th>
                    <th scope="col">선적기일</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data?.crtConfirmationFileDtoList?.length > 0 ? (
                    props.data?.crtConfirmationFileDtoList?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td data-title={'근거서류명 및 번호'}>
                            {
                              fileType.find((file) => {
                                return file.value === item.fileCd
                              })?.title
                            }
                            [{item.fileNo}]
                          </td>
                          <td data-title={'HS부호'}>{item.hsCd}</td>
                          <td data-title={'품명'}>{item.itemnm}</td>
                          <td data-title={'규격'}>{item.itemdeftxt}</td>
                          <td data-title={'금액'}>
                            {item.totamtcur} {item?.amt && commons.addComma(item.amt)}
                          </td>
                          <td data-title={'선적기일'}>{moment(item.stngYmd).format('Y-M-D')}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td colSpan={6}>
                        <div className="nodata">검색된 자료가 없습니다.</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {step === 3 && (
          <div id="buy-tab3" className="tab-cont">
            <div className="tbl-wrap mt30">
              <table className="tbl-list">
                <caption>세금계산서번호, 품명, 규격, 공급가액, 세액, 수량, 선적기일 항목으로 구성</caption>
                <colgroup>
                  <col style={{ width: '14%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '12%' }} />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">세금계산서번호</th>
                    <th scope="col">품명</th>
                    <th scope="col">규격</th>
                    <th scope="col">공급가액</th>
                    <th scope="col">세액</th>
                    <th scope="col">수량</th>
                    <th scope="col">선적기일</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data?.crtConfirmationTaxDtoList?.length > 0 ? (
                    props.data?.crtConfirmationTaxDtoList?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td data-title={'세금계산서번호'}>
                            <span>{item.taxNo}</span>
                          </td>
                          <td data-title={'품명'}>
                            <span>{item.itemnm}</span>
                          </td>
                          <td data-title={'규격'}>
                            <span>{item.itemdeftxt}</span>
                          </td>
                          <td data-title={'공급가액'}>{item?.splyAmt && commons.addComma(item.splyAmt)}</td>
                          <td data-title={'세액'}>{item?.taxAmt && commons.addComma(item.taxAmt)}</td>
                          <td data-title={'수량'}>
                            {item?.itemqty && commons.addComma(item.itemqty)} {item.itemqtyunitcd}
                          </td>
                          <td data-title={'작성일자'}>{moment(item.writedt).format('Y-M-D')}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td colSpan={7}>
                        <div className="nodata">검색된 자료가 없습니다.</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {step === 4 && (
          <div id="buy-tab4" className="tab-cont">
            <table className="tbl-view">
              <caption>발급일자 항목으로 구성</caption>
              <colgroup>
                <col className="col1" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">발급일자</th>
                  <td>{props.data?.issuedt && moment(props.data?.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD')}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        <div className="btn-block">
          <span className="right">
            <a
              href="#"
              className="btn-primary md"
              onClick={(e) => {
                e.preventDefault()
                props.onPDFView()
              }}
            >
              PDF
            </a>
            <a
              href="#"
              className="btn-secondary md"
              onClick={(e) => {
                e.preventDefault()
                props.goList()
              }}
            >
              목록
            </a>
          </span>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const actionCreators = {
  getFile: certboxActions.getFile,
}

export default connect(mapStateToProps, actionCreators)(CertboxForm1)
